<template>
  <section>
    <el-button type="primary" plain @click="toBatchDispatch"
    >批量派车
    </el-button
    >
    <el-button type="primary" plain @click="toBatchCancel"
    >批量取消
    </el-button
    >
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            :height="tableHeight"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55"/>
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
                :key="key"
                :prop="item.prop"
                :label="item.label"
                :sortable="item.sortable"
                :filters="item.filters"
                :filter-method="item.filterHandler"
                :min-width="item.minW"
                :width="item.w"
            >
              <section slot-scope="scope">

                <section>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
              prop="control"
              label="操作"
              width="120"
              fixed="left"
          >
            <template slot-scope="scope">
              <TableBtn
                  :tableData="scope.row"
                  :isShowDropdown="true"
                  :isCenter="false"
                  :btnList="[
                  {
                    permpisions: '',
                    showCondition: scope.row.dispatchOrderStatus===1,
                    name: '查询订单',
                    event: () => toQueryOrder(scope.row),
                  },
                   {
                    permpisions: '',
                    showCondition: scope.row.dispatchOrderStatus===2,
                    // showCondition:true,
                    name: '派车',
                    event: () => toSendCar('',scope.row),
                  },
                   {
                    permpisions: '',
                    showCondition: scope.row.dispatchOrderStatus===2,
                    name: '取消',
                    event: () => toCancel('',scope.row),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操作按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableData.page"
              :page-sizes="[20, 30, 50]"
              :page-size="tableData.count"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </section>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {getReceiptRecordList, orderRevokeByIds, vehicleDispatching} from 'api/operate';
import TableBtn from 'components/tableBtn/tableBtn';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBtn, // 操作按钮
  },
  data () {
    return {
      searchBoxData: {
        sourceOfGoodsId: 0,
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 20,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {prop: 'orderId', label: '订单号'},
          {prop: 'plateNumber', label: '车牌号'},
          {prop: 'dispatchOrderStatusName', label: '派单状态'},
          {prop: 'driverRate', label: '司机运价'},
          {prop: 'driverName', label: '司机姓名'},
          {prop: 'driverPhone', label: '司机手机号'},
          {prop: 'vehicleType', label: '车型'},
          {prop: 'orderReceivingTime', label: '接单时间'},
          {prop: 'opName', label: '操作人'},
          {prop: 'opDate', label: '操作时间'},

        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: getReceiptRecordList,
    toBatchDispatch () { // 批量派车
      let datas = this.tableData.selectResult.filter((data) => data.dispatchOrderStatus == 2);
      if (datas.length === 0) {
        this.$message.warning('请先选择满足派车条件的订单');
      } else {
        this.toSendCar('batch', datas);
      }
    },
    toBatchCancel () { // 批量取消
      let datas = this.tableData.selectResult.filter((data) => data.dispatchOrderStatus == 2);
      if (datas.length === 0) {
        this.$message.warning('请先选择满足取消条件的订单');
      } else {
        this.toCancel('batch', datas);
      }
    },
    toQueryOrder (item, defaultActive = '', defaultChildActive = 'carrier', isVerity) { // 查询订单
      this.$emit('closeModal');
      this.jump({
        label: `订单详情-${item.orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}&defaultActive=${defaultActive}&defaultChildActive=${defaultChildActive}&isVerity=${isVerity}`,
        full: true,
      });
    },
    async toSendCar (type, item) { // 去派车
      let data;
      if (type === 'batch') { // 判断是否为批量派车
        data = item.map((item) => item.id);
      } else {
        data = item.id;
      }
      const res = await vehicleDispatching({
        receiptRecordIds: type === 'batch' ? data.join(',') : data,
      });
      if (!res.failed) {
        this.tableData.selectResult = [];
        this.$message({
          type: 'success',
          message: type === 'batch' ? '批量派车成功' : '派车成功',
        });
        this.getData();
      }
    },
    async toCancel (type, item) { // 取消
      let data;
      if (type === 'batch') { // 判断是否为批量派车
        data = item.map((item) => item.id);
      } else {
        data = item.id;
      }
      const res = await orderRevokeByIds({
        receiptRecordIds: type === 'batch' ? data.join(',') : data,
      });
      if (!res.failed) {
        this.tableData.selectResult = [];
        this.$message({
          type: 'success',
          message: type === 'batch' ? '批量取消订单成功' : '取消订单成功',
        });
        this.getData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
